var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('h1',[_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n    ")]),_vm._v(" "),_c('NuxtLink',{attrs:{"to":"/"}},[_vm._v(" Home page ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }